module.exports = __webpack_public_path__ + "img/chrome.e28962b6.svg";